module.exports = __webpack_public_path__ + "img/trustpilot-1.e03e4a0c.svg";